<template>
<div id="shareContent">
    <van-share-sheet
        v-model="isShow"
        :options="options"
        :close-on-click-overlay="false"
        @select="onSelect"
        @cancel="shareCancel"
        />
    <div>
        <div v-if="posterImg">
            <van-popup 
                v-model="mask"
                get-container="#shareContent"
                class="oter"
                >
                <div>
                    <img :src="posterImg" class="poster-bg" alt="分享图片">
                    <!-- <img src="@/assets/icons/xiazai.png" class="download" @click="download()" alt="下载图标"> -->
                    <!-- <van-icon class="close" color="#fff" size="30" name="close" @click="mask=false" /> -->
                </div>
            </van-popup >
        </div>
        <div v-else class="hidden">
            <div id="box">
                <div>
                    <img  class="img" :src="info.photo_l" style="width:100%" alt="图片">
                </div>
                <div class="name">{{info.name}}</div>
                <div class="smallSize">{{info.goods_trait}}</div>
                <div class=" bigSize red priceM">￥<span class="price">{{info.price==undefined ? "0" : info.price[0]}}</span>起</div>
                <div class="line">
                    <div v-for="(item,index) of 30" :key="index" class="lineStyle"></div>
                </div>
                <div class="qrcodeBox">
                    <div id="qrcode" ref="qrCodeDiv" v-if="imgData==''"></div>
                    <div class="qrcodeText">
                        <div class="bigSize press">长按识别二维码 了解详情</div>
                        <!--pjh <div class="smallSize" v-if="$store.state.userInfo.user_type==1">保险经纪人：{{$store.state.userInfo.user_nickname}}</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
     <van-popup 
        v-model="shareAlert"
        get-container="#shareContent"
        class="shanreAlert"
        >
        <div @click="shareAlert=false">
            <div class="cuspDiv">
                <img class="cusp" src="@/assets/imgs/cusp.png" alt="">
            </div>
            <div>
                点击按钮分享好友
            </div>
        </div>
    </van-popup >
</div>
</template>
<script>
import {Toast} from 'vant'
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
export default {
    props:["showShare","info","shareBaseUrl"],
    data(){
        return {
            options: [
                { name: '微信分享', icon: require("@/assets/imgs/weixin.png")},
                { name: '生成图片', icon: require("@/assets/imgs/image.png") },
            ],
            posterImg:false,
            mask:false,
            imgData:"",
            shareAlert:false
        }
    },
    mounted(){
    },
    methods:{
        shareCancel(){
            this.$emit("isShowShare",false);
        },
        //分享
        onSelect(option) {
            if(option.name=="生成图片"){
                let url=this.shareBaseUrl;
                console.log('url'+url)
                this.qrCode(url);
            }else if(option.name=="微信分享"){
                this.shareAlert=true;
            }
            this.$emit("isShowShare",false);
        },
        qrCode (url) {
            let qrcode = new QRCode('qrcode', {
                width: 100, //图像宽度
                height: 100, //图像高度
                colorDark : "#000000", //前景色
                colorLight : "#ffffff", //背景色
                typeNumber:4, 
                correctLevel : QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
            })
            qrcode.clear(); //清除二维码 
            qrcode.makeCode(url); //生成另一个新的二维码
            setTimeout(() => {   //渲染需要时间，不然报类型error(但是不影响使用)
                this.createPoster();
            }, 500);
        },
        //使用html2canvas生成海报
        createPoster() {
            // 生成海报
            const vm = this;
            const domObj = document.getElementById('box');
            html2canvas(domObj,{useCORS: true,logging: false}).then(canvas=>{
                // 在微信里,可长按保存或转发 posterImg 生成的海报路径
                vm.posterImg = canvas.toDataURL('image/png');
                vm.mask = true;
            });
        },
    },
    watch:{
        mask(e){
            if(!e){
                this.posterImg="";
            }
        }
    },
    computed:{
        isShow:{
            get(){
                return this.showShare;
            },
            set(newValue){
                return newValue
            }
        },
       
    },
}
</script>
<style scoped>
    .oter {
        /* padding: 15px; */
        overflow-y: visible;
    }
    .poster-bg{
        width: 100%;
    }
    .qrcodeBox{
        margin: 15px;
        padding:12px;
        display: flex;
        /* justify-content: space-around; */
    }
    .qrcodeText{
        margin-left: 18px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }
    .hidden{
        position: fixed;
        bottom: -1000px;
    }
    .img{
        border-radius: 4px;
    }
    .download{
        width: 30px;
        height: 30px;
        position: absolute;
        bottom: -68px;
        left: 50%;
        transform: translate(-50%,0);
    }
    #shareContent /deep/ .van-share-sheet__name{
        font-size: 14px;
    }
    #shareContent /deep/ .van-share-sheet__cancel{
        height: 45px;
        /* line-height: 45px; */
    }
    #shareContent /deep/ .van-share-sheet__options{
        /* width: 330px; */
        margin: 0 70px;
        justify-content: space-between;
        padding:27px 0;
    }
    #shareContent /deep/ .van-share-sheet__cancel::before{
        height: 1px;
        background-color:rgba(241,241,241,1);
        content: ' ';
        width: 330px;
        margin: 0 auto;
    }
    #shareContent /deep/ .van-popup--bottom{
        overflow: hidden;
    }
    #shareContent /deep/ .van-popup--center{
        width: 58%;
        padding: 12px;
    }
    .name{
        font-size: 19px;
        color: #333;
        font-weight: 600;
        margin-bottom: 5px;
    }
    .priceM{
        margin:12px 0;
    }
    .price{
         font-size: 22px;
    }
    .bigSize{
        font-size: 17px;
        color: #333;
    }
    .smallSize{
        font-size: 15px;
        color: #999;
    }
    .line{
        display: flex;
        justify-content: space-around;
        margin: 0 12px;
    }
    .lineStyle{
        width:2%;height:2px;background:#C2C2C2
    }
    .press{
        color: #333;
        font-weight: 600;
        margin-bottom: 8px;
    }
    /* 分享弹窗 */
    .shanreAlert{
        width: 100% !important;
        background: transparent;
        color: #FFF;
        font-size: 18px;
        top:0;
        transform:translate(-50%,0)
    }
    .cuspDiv{
        text-align: end;
    }
    .cusp{
        width:143px;
        height: 161px;
        margin-right: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/share.vue